<template>
  <!-- The anchor is this component's one element, so that a call site's v-show
       (ServerStatus keeps two overlays mounted and shows one) still works on
       it. It takes no room (`display: contents`); the dialog inside it is
       position: fixed over the whole page. -->
  <span ref="anchor" class="overlayWindowAnchor" style="display: contents">
    <UiDialog
      v-bind="$attrs"
      :open="shown"
      frame
      inline
      content-as="dialog"
      class="overlayWindow"
      :size="size"
      :box-class="['content', size]"
      actions-class="actions"
      close-class="closeOverlay"
      :close-button="closeButton"
      :hide-actions="hideActions"
      @update:open="(open) => open || close()"
    >
      <template #title><slot name="title"></slot></template>
      <slot></slot>
      <template v-if="$slots.actions" #actions><slot name="actions"></slot></template>
    </UiDialog>
  </span>
</template>

<script>
import UiDialog from '../ui/UiDialog.vue'

// A window over the page, open for as long as it is mounted. Since #548 it is a
// UiDialog (Reka Dialog) in its framed form: this wrapper keeps what its call
// sites and the e2e suite know it by — `dialog.overlayWindow`, its `h2`, the
// `.content` box with its size class, `.closeOverlay`, the `.actions` row with
// «OK» or the actions slot — and the way it talks: it never closes itself;
// OK, the close button and Escape all emit `done`.
export default {
  name: 'overlayWindow',
  components: { UiDialog },
  inheritAttrs: false,
  props: {
    size: { required: false, default: 'medium' }, //medium larga
    hideActions: { type: Boolean, default: false },
    closeButton: { type: Boolean, default: false },
  },
  emits: ['done'],
  data() {
    return {
      shown: true,
    }
  },
  mounted() {
    // v-show on this component sets `display: none` on the anchor, which hides
    // the window; follow it, so a hidden window does not keep the page's focus
    // and scroll locked.
    const read = () => {
      this.shown = this.$refs.anchor.style.display !== 'none'
    }
    read()
    this.observer = new MutationObserver(read)
    this.observer.observe(this.$refs.anchor, { attributes: true, attributeFilter: ['style'] })
  },
  beforeUnmount() {
    this.observer?.disconnect()
  },
  methods: {
    close() {
      this.$emit('done')
    },
  },
}
</script>

<style lang="scss">
// The old box's own values, where UiDialog's differ: the close button's icon.
.overlayWindow .closeOverlay svg {
  stroke: var(--primary);
}
</style>
